'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Expand = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Expand, _Component);

  function Expand() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Expand);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Expand.__proto__ || (0, _getPrototypeOf2.default)(Expand)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expand: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Expand, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({ expand: !this.state.expand });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CommonUI.scss');
      var expand = this.state.expand;
      var _props = this.props,
          title = _props.title,
          icon = _props.icon,
          flag = _props.flag,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        { className: styles.box + ' ' + (expand ? styles.expand : '') },
        _react2.default.createElement(
          'div',
          { className: styles.boxHead },
          title && _react2.default.createElement(
            'div',
            { className: styles.titleTypes, onClick: this.toggle.bind(this) },
            _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: icon }),
            title
          ),
          flag && _react2.default.createElement(
            'div',
            { className: styles.flag },
            flag
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.pWrapper },
          children
        )
      );
    }
  }]);
  return Expand;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  children: _react.PropTypes.object,
  title: _react.PropTypes.string,
  flag: _react.PropTypes.string,
  icon: _react.PropTypes.string
}, _temp2);

Expand.defaultProps = {
  className: '',
  title: '',
  icon: ''
  // onClick: function(){},
};
exports.default = Expand;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CategoryMobile/Expand.js
// module id = 1542
// module chunks = 0